<app-ceb-wizard-header *ngIf="useCebWizardShell(); else defaultHeader"></app-ceb-wizard-header>
<ng-template #defaultHeader>
  <app-header></app-header>
</ng-template>
<ion-content>
  <router-outlet></router-outlet>
</ion-content>
